import variables from '../variables';

import BurgerIconSVG from '../../assets/images/ellipsis.svg';

/* eslint-disable */
const MuiButton = {
  root: {
    '&.ellipsis': {
      background: `url("${BurgerIconSVG}") no-repeat center center`,
      backgroundSize: '17px 17px',
      display: 'inline-block',
      height: '35px',
      width: '35px',
      position: 'relative',
      cursor: 'pointer',
    },
  },
  outlined: {
    backgroundColor: variables.colors.midBlue,
    textTransform: 'uppercase',
    margin: '20px 0',
    borderRadius: '22px',
    padding: '5px 20px',
    border: `2px solid ${variables.colors.coral}`,
    '&:hover': {
      background: variables.colors.coral,
    },
  },
  text: {
    color: variables.colors.coral,
    padding: '0',
    margin: '0',
  },
};

export default MuiButton;
